import React from "react";

export const DuckIcon: React.FC = () => {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
      <g id="color">
        <path
          fill="#6A462F"
          stroke="none"
          d="M34.6024,63.9305c1.1633,0,2.6989,0,4.1493,0c2.3257,0,4.432,0,4.432,0s3.0287,0.5048-0.5048-3.0287 c0,0,0.5048-1.0096,0.5048-1.5143s1.0937-1.0096,0.7992-2.0191"
        />
        <path
          fill="#6A462F"
          stroke="#6A462F"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M37.8007,61.4321 c1.129-0.1524,1.9462-0.423,2.3542-1.035c1.0096-1.5143,1.0096-1.0096,0.5048-2.0191c-0.5048-1.0096,0-2.0191,0-2.0191L45,57"
        />
        <path
          fill="#A57939"
          stroke="none"
          d="M33.7901,53.9699c9.417,4.7375,29.5174,3.7978,25.572-0.1477c-4.4391-4.4391-5.0732-6.3416-5.7074-10.1465 s-5.7074-11.4148-14.5856-13.3173c-8.8782-1.9025,0-13.9514-6.3416-19.6588s-13.9514-0.6342-13.9514,2.5366 s-3.1708,5.0732-3.1708,5.0732c-1.2683,0.6342-9.5123,3.8049,1.2683,3.8049s10.1465,2.5366,6.9757,4.4391 c0,0-10.8078,4.5851-7.8493,14.4465c3,10,17.9958,13.4564,17.9958,13.4564s-0.6342,1.2683,0,2.5366s-0.3658,1.6342-1.6342,3.5366 c-1.2683,1.9025-4.0732,0.2683-6.6099,0.9025c-1.9455,0.4864-3.1708,2.5366,0.6342,2.5366s10.7806,0,10.7806,0 s3.8049,0.6342-0.6342-3.8049c0,0,0.6342-1.2683,0.6342-1.9025s1.374-1.2683,1.0041-2.5366"
        />
        <path
          fill="#5C9E31"
          stroke="none"
          d="M39.0691,30.3584c-8.8782-1.9025,0-13.9514-6.3416-19.6588s-13.9514-0.6342-13.9514,2.5366 s-3.1708,5.0732-3.1708,5.0732c-1.2683,0.6342-9.5123,3.8049,1.2683,3.8049s10.1465,2.5366,6.9757,4.4391"
        />
        <path
          fill="#FCEA2B"
          stroke="none"
          d="M15.6053,18.3095c-1.2683,0.6342-9.5123,3.8049,1.2683,3.8049"
        />
      </g>
      <g id="hair" />
      <g id="skin" />
      <g id="skin-shadow" />
      <g id="line">
        <path
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M47.9472,46.2123c6.9757,5.7074,0,6.3416,0,6.3416c-17.1222,1.9025-21.5613-16.488-21.5613-16.488"
        />
        <path
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M34.0168,54.4596c10.7957,2.9088,29.2906,3.308,25.3452-0.6374c-4.4391-4.4391-5.0732-6.3416-5.7074-10.1465 s-5.7074-11.4148-14.5856-13.3173c-8.8782-1.9025,0-13.9514-6.3416-19.6588s-13.9514-0.6342-13.9514,2.5366 s-3.1708,5.0732-3.1708,5.0732c-1.2683,0.6342-9.5123,3.8049,1.2683,3.8049s10.1465,2.5366,6.9757,4.4391 c0,0-10.8078,4.5851-7.8493,14.4465c3,10,17.9958,13.4564,17.9958,13.4564s-0.6342,1.2683,0,2.5366s-0.3658,1.6342-1.6342,3.5366 c-1.2683,1.9025-4.0732,0.2683-6.6099,0.9025c-1.9455,0.4864-3.1708,2.5366,0.6342,2.5366s10.7806,0,10.7806,0 s3.8049,0.6342-0.6342-3.8049c0,0,0.6342-1.2683,0.6342-1.9025s1.374-1.2683,1.0041-2.5366"
        />
        <path
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M34.6024,63.9305c1.1633,0,2.6989,0,4.1493,0c2.3257,0,4.432,0,4.432,0s3.0287,0.5048-0.5048-3.0287 c0,0,0.5048-1.0096,0.5048-1.5143s1.0937-1.0096,0.7992-2.0191"
        />
        <path
          fill="none"
          stroke="#000000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="2"
          d="M40.6597,56.3588c0,0-0.5048,1.0096,0,2.0191c0.5048,1.0096,0.5048,0.5048-0.5048,2.0191c-0.408,0.612-1.2252,0.8826-2.3542,1.035"
        />
      </g>
    </svg>
  );
};
